<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1>
        <a routerLink="/fleet">Fleet</a> > {{vehicleMaintenance?.name}}
        <a routerLink="/update-vehicle/{{vehicleMaintenance?.id}}"><span style="font-size: 0.7em;"><fa-icon [icon]="faPen"></fa-icon></span></a>
      </h1>
    </div>
  </div>
</div>

<p>
  Current mileage:
  <a routerLink="/update-vehicle/{{vehicleMaintenance?.id}}">{{vehicleMaintenance?.mileage | number}} &nbsp;<fa-icon [icon]="faPen"></fa-icon></a>
</p>

@if (vehicleMaintenance?.vin) {
  <p>
    VIN: {{vehicleMaintenance?.vin}}
    &nbsp;
    <a routerLink="/update-vehicle/{{vehicleMaintenance?.id}}"><fa-icon [icon]="faPen"></fa-icon></a>
  </p>
}

@if (vehicleMaintenance?.shared) {
  <p>
    Shared at <a routerLink="/share/{{vehicleMaintenance?.id}}">https://wrench.cafe/share/{{vehicleMaintenance?.id}}</a>
    &nbsp;
    <a routerLink="/update-vehicle/{{vehicleMaintenance?.id}}"><fa-icon [icon]="faPen"></fa-icon></a>
  </p>
}

@if (!vehicleMaintenance?.shared) {
  <p>
    Currently not shared
    &nbsp;
    <a routerLink="/update-vehicle/{{vehicleMaintenance?.id}}"><fa-icon [icon]="faPen"></fa-icon></a>
  </p>
}

<a routerLink="/record-maintenance/{{vehicleMaintenance?.id}}">
  <button class="btn btn-primary" title="Add a new maintenance record for this vehicle">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</a>

<table class="table table-hover">
  <thead>
    <tr>
      <th>Date</th>
      <th>Mileage</th>
      <th>Maintenance</th>
      <th>Due Date</th>
      <th>Due Mileage</th>
      <th class="fit">
      </th>
    </tr>
  </thead>
  <tbody>
    @for (maintenance of vehicleMaintenance?.maintenance; track maintenance) {
      <tr>
        <td>{{maintenance.date | date}}</td>
        <td>{{maintenance.mileage | number}}</td>
        <td>{{maintenance.item}}</td>
        <td>{{maintenance.dueDate | date}} @if (today > maintenance.dueDate) {
          <span class="badge badge-warning">Due</span>
        }</td>
        <td>{{maintenance.dueMileage | number}} @if (vehicleMaintenance.mileage > maintenance.dueMileage) {
          <span class="badge badge-warning">Due</span>
        }</td>
        <td class="fit">
          <div class="btn-group">
            <button class="btn btn-secondary" [disabled]="!maintenance.receipt" (click)="downloadReceipt(maintenance.receipt)" title="Download receipt">
              <fa-icon [icon]="faReceipt"></fa-icon>
            </button>
            <button class="btn btn-secondary" placement="bottom" [ngbPopover]="maintenance.notes" popoverTitle="Notes" [autoClose]="'outside'" [disabled]="!maintenance.notes" title="View notes">
              <fa-icon [icon]="faStickyNote"></fa-icon>
            </button>
            <a [routerLink]="'/update-maintenance/' + vehicleMaintenance?.id + '/' + maintenance.id" class="btn btn-secondary" title="Edit this maintenance record">
              <fa-icon [icon]="faEdit"></fa-icon>
            </a>
            <button class="btn btn-secondary" (click)="delete(maintenance.id)" title="Delete this maintenance record">
              <fa-icon [icon]="faTrash"></fa-icon>
            </button>
          </div>
        </td>
      </tr>
    }
    @if (vehicleMaintenance?.maintenance.length == 0) {
      <tr><td colspan="6">There is currently no recorded maintenance for this vehicle. Click one of the plus (+) buttons to add some!</td></tr>
    }
  </tbody>
</table>

<a routerLink="/record-maintenance/{{vehicleMaintenance?.id}}">
  <button class="btn btn-primary" title="Add a new maintenance record for this vehicle">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</a>